export default function DashboardCardFilters({ children }) {
  return (
    <div
      className="w-full flex mb-4"
      style={{
        gap: '24px'
      }}
    >
      {children}
    </div>
  );
}
